import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { INROUTES } from './../common/links';

import IcSkytone from './../assets/icon/ic-skytone.svg';
import IcLogo from './../assets/icon/bi-dafthings.svg';

const renderHomeButton = (type) => {
    let logoButton;
    switch(type){
        case 'home':
            logoButton = (<Link to={INROUTES.HOME} className="bi" name="page"><button type="button"><span className="icon dafthings"><img src={IcLogo} alt="Dafthings Logo" className="svg dthing"/><img src={IcSkytone} alt="Skytone Logo" className="svg prod"/></span></button></Link>);
        break;
        default:
            logoButton = (<Link to={INROUTES.SKYTONE} className="bi" name="page"><button type="button"><span className="icon daftprod"><img src={IcLogo} alt="Dafthings Logo" className="svg dthing"/><img src={IcSkytone} alt="Skytone Logo" className="svg prod"/></span></button></Link>);
        break;
    }
    return logoButton;
}

const Nav = ({ handleMenu, page }) => {
    //const [navValue, setNavValue] = useState(page?.toLowerCase());
    const [homeButton, setHomeButton] = useState(page?.toLowerCase());

    useEffect(() => {
        setHomeButton(<>{renderHomeButton(page?.toLowerCase())}</>)
        //setNavValue(page.toLowerCase());
    }, [page]); // page 변경될 때마다 실행

    const changeMenu= () => {
        handleMenu();
    }
    return (
        <header id="header">
            <div className="wrap flx">
                {homeButton}
                <span className="blank"></span>
                <button type="button" className="nav" onClick={changeMenu}><span className="icon"><i className="bar"></i></span></button>
            </div>
        </header>
    );
};

export default Nav;